import { render, staticRenderFns } from "./DialogUsersAndCategoryEditUserGroup.vue?vue&type=template&id=0c833eb6"
import script from "./DialogUsersAndCategoryEditUserGroup.vue?vue&type=script&lang=js"
export * from "./DialogUsersAndCategoryEditUserGroup.vue?vue&type=script&lang=js"
import style0 from "./DialogUsersAndCategoryEditUserGroup.vue?vue&type=style&index=0&id=0c833eb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports